"use client"

import CTA from "@/components/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

const laptopBandung: ReactNode = (
  <>
    <h2 className="text-xl font-bold mb-2">Laptop Bukan Sekadar Alat, Tapi Senjata Perang Digital</h2>

    <h3 className="text-lg font-semibold mb-2">
      Sewa Laptop Bandung: Strategi Tanpa Risiko untuk Pekerjaan Besar & Misi Cepat
    </h3>

    <p className="mb-4">
      Di kota kreatif yang nyaris tak pernah tidur ini, <strong>sewa laptop Bandung</strong> bukan sekadar solusi, tapi keharusan. Dari event kampus di Jatinangor, pelatihan startup di Lembang, hingga pameran teknologi di Cihampelas, laptop bukan lagi alat tambahan, tapi garda depan produktivitas. Kamu tak perlu beli, cukup sewa, langsung pakai, dan tugas² selesai.
    </p>

    <div className="space-y-4 mb-6">
      <div className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h2 className="font-semibold text-lg mb-2">Pengiriman Kilat ke Semua Zona Bandung Raya</h2>
        <p className="text-sm">
          Area <strong>sewa laptop Bandung</strong> mencakup Dago, Cibiru, Cimahi, Lembang, bahkan pelosok seperti Soreang. Jalan sempit atau hujan deras? Kami tetap antar, karena fleksibilitas adalah bagian dari layanan. Kami tak cuma menjangkau lokasi, tapi juga mindset klien: cepat, presisi, zero drama.
        </p>
      </div>

      <div className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Laptop Siap Tempur untuk Acara Edukasi & Event Teknologi</h3>
        <p className="text-sm">
          Tak ada waktu install? Unit kami sudah terpasang Office, Photoshop, AutoCAD, bahkan OBS & Zoom. Cocok untuk pelatihan desain, seminar, coding bootcamp, atau acara hybrid. <strong>Sewa laptop Bandung</strong> artinya laptop langsung colok, tanpa setup².
        </p>
      </div>

      <div className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Harga Sewa Laptop Bandung Fleksibel, Tanpa Drama</h3>
        <p className="text-sm">
          Mau sewa 3 hari? 1 minggu? 1 bulan? Semua bisa. <strong>Harga sewa laptop Bandung</strong> menyesuaikan budget: dari harian hingga bulanan. Tersedia laptop ekonomis, mid-tier hingga high-end untuk desain berat & gaming. Butuh 1 unit atau 100 unit? Kami cover.
        </p>
      </div>

      <div className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Brand, Tipe & Spesifikasi: Kamu yang Tentukan</h3>
        <p className="text-sm">
          Dari <strong>MacBook Pro, Dell Latitude, Asus TUF</strong>, hingga <strong>Lenovo ThinkPad</strong>, pilihan lengkap. Processor i5, i7, RAM 8-32 GB, SSD 256-1TB? Semua bisa dipilih. Spesifikasi menyesuaikan kebutuhan dan timeline.
        </p>
      </div>

      <div className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Support Teknis 24 Jam & Backup Cepat</h3>
        <p className="text-sm">
          Saat event berlangsung, error 1 menit pun bisa fatal. Kami hadir dengan support langsung ke lokasi dan backup unit <strong>sewa laptop Bandung</strong> on standby. Kalau unit ngadat, langsung ganti. Kamu tinggal lanjut presentasi.
        </p>
      </div>
    </div>

    <h2 className="text-xl font-bold mb-3">Gratis Ongkir & Layanan Antar Jemput Langsung</h2>
    <p className="mb-4">
      Semua unit <strong>sewa laptop Bandung</strong> dikirim langsung tanpa biaya tambahan untuk area kota. Untuk wilayah sekitarnya (Cileunyi, Lembang, Cimahi, Baleendah), bisa antar jemput dengan biaya logistik ringan. Kebutuhan laptopmu dijemput & dikembalikan tanpa ribet.
    </p>

    <h2 className="text-xl font-bold mb-3">Fleksibel Durasi, Fleksibel Kebutuhan</h2>
    <p className="mb-4">
      Tak semua pekerjaan butuh laptop permanen. Kadang kamu hanya butuh 2 hari untuk bootcamp atau sebulan untuk tender proyek. Di sinilah <strong>sewa laptop Bandung</strong> jadi solusi taktis: fleksibel secara waktu, efisien secara biaya.
    </p>

    <h2 className="text-xl font-bold mb-3">Data Aman & Unit Selalu Fresh</h2>
    <p className="mb-4">
      Kami bersihkan data setiap unit selesai digunakan. Instalasi software selalu versi terbaru. Jadi kamu tak hanya pakai laptop bersih, tapi juga tanpa risiko digital. Kami jaga reputasimu seperti menjaga milik sendiri.
    </p>

    <CTA
      title="Siap Kerja Editing & Olah Data Dimana² Bosku?"
      description="🚚 Butuh sewa laptop terdekat sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking Laptop Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20laptop.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ
      category="Laptop"
    />
  </>
);

export default laptopBandung;